const Definitions = {
  GalleryPagesBasePath: '/galerie/',
  AboutPagePath: '/uber/',
  ImprintPagePath: '/impressum/',
  GalleryPhotosBasePath: '/photos/',
}

export default Definitions;